<template>
  <div class="MenuList">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
// Composant wrapper pour la liste de menu
</script>

<style scoped>
.MenuList {
  padding: 0.5rem 0;
  min-width: 200px;
}
</style>
